// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { staticListHeaderStyles } from "@insite/content-library/Widgets/StaticList/StaticListHeader";
import { titleStyles } from "@rugby/Overrides/Widgets/Basic/PageTitle";
import { css } from "styled-components";

staticListHeaderStyles.listNameTextField = {
    ...staticListHeaderStyles.listNameTextField,
    cssOverrides: {
        formField: css`
            margin-top: 20px;
            label {
                text-align: left;
                padding: 0 0 0 10px;
            }
        `,
    },
};

staticListHeaderStyles.nameText = {
    ...staticListHeaderStyles.nameText,
    ...titleStyles.titleText,
};

staticListHeaderStyles.infoGridItem = {
    ...staticListHeaderStyles.infoGridItem,
    css: css`
        ${staticListHeaderStyles.infoGridItem?.css}
        &&& {
            margin: 50px 0 40px 0;
        }
    `,
};

staticListHeaderStyles.addListToCartGridItem = {
    ...staticListHeaderStyles.addListToCartGridItem,
    css: css`
        ${staticListHeaderStyles.addListToCartGridItem?.css}
        align-items: center;
    `,
};

staticListHeaderStyles.saveListGridItem = {
    ...staticListHeaderStyles.saveListGridItem,
    css: css`
        ${staticListHeaderStyles.saveListGridItem?.css}
        align-items: center;
    `,
};
